<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>改衣单管理</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchGyd"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="Clickcreate"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="iconfont icon-xiugai1"
          @click="modifyGyd"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="lookgyd"
          >查看</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="Deletegyd"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.daochu"
          icon="el-icon-folder-opened"
          @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          v-if="jurisdiction.daochu"
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="32%"
        title="改衣单-创建"
        :visible.sync="foundFormVisible"
        :close-on-click-modal="false"
        @close="CreatedClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="createhy"
            :rules="createFormgydRules"
            ref="createhyRef"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="改衣单号" prop="orderNo">
                  <el-input
                    style="width: 65%"
                    :disabled="true"
                    v-model="createhy.orderNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="销售单号" prop="saleNo">
                  <!-- <div class="flex-between"> -->
                  <el-input style="width: 65%" v-model="createhy.saleNo">
                  </el-input>
                  <el-button
                    @click="Salesslip"
                    style="
                      width: 90px;
                      margin-left: 10px;
                      background-color: rgb(241, 241, 241);
                      color: #4d4d4d;
                    "
                    size="small"
                    >选择销售单</el-button
                  >
                  <!-- </div> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="门店" prop="shopName">
                  <el-input
                    style="width: 65%"
                    :disabled="true"
                    v-model="createhy.shopName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户姓名" prop="custName">
                  <!-- <div class="flex-between"> -->
                  <el-input style="width: 65%" v-model="createhy.custName">
                  </el-input>
                  <el-button
                    style="
                      width: 90px;
                      margin-left: 10px;
                      background-color: rgb(241, 241, 241);
                      color: #4d4d4d;
                    "
                    size="small"
                    @click="Selecthy"
                    >选择会员</el-button
                  >
                  <!-- </div> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="商品条码" prop="barCode">
                  <el-input
                    style="width: 65%"
                    :disabled="true"
                    v-model="createhy.barCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="改衣单状态" prop="state">
                  <el-select style="width: 65%" v-model="createhy.state">
                    <el-option label="已交付" value="0"></el-option>
                    <el-option label="待取衣" value="1"></el-option>
                    <el-option label="修改中" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="费用类型" prop="payWay">
                  <el-select style="width: 65%" v-model="createhy.payWay">
                    <el-option label="自费 " value="0"></el-option>
                    <el-option label="保修需报销" value="1"></el-option>
                    <el-option label="保修无需报销" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改费用" prop="fee">
                  <el-input
                    oninput="value=value.replace(/[^\d]/g,'')"
                    style="width: 65%"
                    v-model="createhy.fee"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="修改内容" prop="modifyContext">
                  <el-input
                    type="textarea"
                    style="width: 65%"
                    :rows="5"
                    v-model="createhy.modifyContext"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改类型" prop="modifyKind">
                  <el-select style="width: 65%" v-model="createhy.modifyKind">
                    <el-option label="常规修改" value="0"></el-option>
                    <el-option label="瑕疵修改" value="1"></el-option>
                    <el-option label="皮草修改" value="2"></el-option>
                    <el-option label="配饰修复" value="3"></el-option>
                    <el-option label="其他修改" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="预计交货日期" prop="deliveryDate">
                  <el-date-picker
                    style="width: 65%"
                    v-model="createhy.deliveryDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addGyd('createhyRef')">保 存</el-button>
          <el-button @click="foundFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 选择销售单弹窗 -->
      <div class="sales">
        <el-dialog
          width="55%"
          title="改衣单-创建-选择销售单"
          :visible.sync="innerVisible"
          :close-on-click-modal="false"
        >
          <div style="width: 450px; margin-top: 10px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="80px"
            >
              <el-form-item label="销售单号">
                <div class="flex-between">
                  <el-input style="width: 300px" v-model="searchXsFrom.saleNo">
                  </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="mini"
                    icon="el-icon-search"
                    @click="SearchXsd"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-table
              size="small"
              class="table-style"
              height="280px"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="tableData2"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="loadxs"
              v-loading="loadingxs"
              infinite-scroll-disabled="onLoadingxs"
            >
              <el-table-column label width="30">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radioxsd"
                    @change.native="getCurrentRow(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="saleNo" label="销售单号">
              </el-table-column>
              <el-table-column prop="saleDate" label="销售日期">
                <template slot-scope="scope">
                  {{ scope.row.saleDate | dateFormat }}
                </template>
              </el-table-column>
              <el-table-column prop="shopName" min-width="90%" label="门店">
              </el-table-column>
              <el-table-column prop="custName" label="购买顾客">
              </el-table-column>
              <el-table-column prop="sheetAmount" label="总单金额">
              </el-table-column>
              <el-table-column prop="barCode" label="商品条码">
              </el-table-column>
              <el-table-column prop="sku" label="SKU"> </el-table-column>
              <el-table-column prop="itemStatus" label="状态">
                <template slot-scope="scope">
                  {{
                    scope.row.itemStatus === 0
                      ? "正常销售"
                      : scope.row.itemStatus === 1
                      ? "已被退货"
                      : scope.row.itemStatus === 2
                      ? "已被换货"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格"> </el-table-column>
              <el-table-column prop="discount" label="折扣"> </el-table-column>
            </el-table>
            <el-alert
              v-if="isMorexs"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="selectxsd">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 选择会员单弹窗 -->
      <div class="choose">
        <el-dialog
          width="55%"
          title="改衣单-创建-选择会员"
          :visible.sync="innerVisible2"
          :close-on-click-modal="false"
        >
          <div style="width: 570px; margin-top: 10px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="200px"
            >
              <el-form-item label="会员姓名\会员卡号\手机号">
                <div class="flex-between">
                  <el-input style="width: 300px" v-model="SearchFormHy.search">
                  </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="mini"
                    icon="el-icon-search"
                    @click="SearchHy"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-table
              size="small"
              class="table-style"
              border
              height="280px"
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="tableData3"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="loadhy"
              v-loading="loadinghy"
              infinite-scroll-disabled="onLoadinghy"
            >
              <el-table-column label width="30">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radiohy"
                    @change.native="getSelectHy(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>

              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="custName" label="会员姓名">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号"> </el-table-column>
              <el-table-column prop="levelName" label="消费等级">
              </el-table-column>
              <el-table-column prop="regionName" label="所属区域">
              </el-table-column>
              <el-table-column prop="shopName" label="所属门店">
              </el-table-column>
              <el-table-column prop="serviceEmpName" label="维护品牌顾问">
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMorehy"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="selecthycz">确 定</el-button>
            <el-button @click="innerVisible2 = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="32%"
        title="改衣单-修改"
        :visible.sync="amendFormVisible"
        @close="modifyClosed"
        :close-on-click-modal="false"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            ref="modifyGydlistRef"
            :model="modifyGydlist"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="改衣单号" prop="orderNo">
                  <el-input
                    style="width: 65%"
                    v-model="modifyGydlist.orderNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="销售单号" prop="saleNo">
                  <el-input
                    style="width: 65%"
                    v-model="modifyGydlist.saleNo"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="门店" prop="shop">
                  <el-input
                    style="width: 65%"
                    v-model="modifyGydlist.shopName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户姓名" prop="custName">
                  <el-input
                    style="width: 65%"
                    v-model="modifyGydlist.custName"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="商品条码" prop="barCode">
                  <el-input
                    style="width: 65%"
                    v-model="modifyGydlist.barCode"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="改衣单状态" prop="state">
                  <el-select style="width: 65%" v-model="modifyGydlist.state">
                    <el-option label="已交付" :value="0"></el-option>
                    <el-option label="待取衣" :value="1"></el-option>
                    <el-option label="修改中" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="费用类型" prop="payWay">
                  <el-select style="width: 65%" v-model="modifyGydlist.payWay">
                    <el-option label="自费 " :value="0"></el-option>
                    <el-option label="保修需报销" :value="1"></el-option>
                    <el-option label="保修无需报销" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改费用" prop="fee">
                  <el-input
                    oninput="value=value.replace(/[^\d]/g,'')"
                    style="width: 65%"
                    v-model="modifyGydlist.fee"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="修改内容" prop="modifyContext">
                  <el-input
                    :rows="5"
                    style="width: 65%"
                    type="textarea"
                    v-model="modifyGydlist.modifyContext"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改类型" prop="modifyKind">
                  <el-select
                    style="width: 65%"
                    v-model="modifyGydlist.modifyKind"
                  >
                    <el-option label="常规修改" :value="0"></el-option>
                    <el-option label="瑕疵修改" :value="1"></el-option>
                    <el-option label="皮草修改" :value="2"></el-option>
                    <el-option label="配饰修复" :value="3"></el-option>
                    <el-option label="其他修改" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="预计交货日期" prop="deliveryDate">
                  <el-date-picker
                    style="width: 65%"
                    v-model="modifyGydlist.deliveryDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyGydqd">确 定</el-button>
          <el-button @click="amendFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="look">
      <el-dialog
        width="32%"
        title="改衣单-查看"
        :close-on-click-modal="false"
        :visible.sync="lookFormVisible"
        @close="SeeGydlbClose"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="lookFormLabelgyd"
            ref="SeeGydlbRef"
          >
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="改衣单号" prop="orderNo">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.orderNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="销售单号" prop="saleNo">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.saleNo"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="门店" prop="shopName">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.shopName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户姓名" prop="custName">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.custName"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="商品SKU" prop="sku">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.sku"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="改衣单状态" prop="state">
                  <el-select
                    style="width: 65%"
                    v-model="lookFormLabelgyd.state"
                    :disabled="true"
                  >
                    <el-option label="已交付" :value="0"></el-option>
                    <el-option label="待取衣" :value="1"></el-option>
                    <el-option label="修改中" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="费用类型" prop="state">
                  <el-select
                    style="width: 65%"
                    v-model="lookFormLabelgyd.payWay"
                    :disabled="true"
                  >
                    <el-option label="自费" :value="0"></el-option>
                    <el-option label="保修需报销" :value="1"></el-option>
                    <el-option label="保修无需报销" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改费用" prop="fee">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.fee"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="修改内容" prop="modifyContext">
                  <el-input
                    style="width: 65%"
                    :rows="5"
                    v-model="lookFormLabelgyd.modifyContext"
                    type="textarea"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="修改类型" prop="modifyKind">
                  <el-select
                    style="width: 65%"
                    v-model="lookFormLabelgyd.modifyKind"
                    :disabled="true"
                  >
                    <el-option label="常规修改" :value="0"></el-option>
                    <el-option label="瑕疵修改" :value="1"></el-option>
                    <el-option label="皮草修改" :value="2"></el-option>
                    <el-option label="配饰修复" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="预计交货日期" prop="deliveryDate">
                  <el-date-picker
                    style="width: 65%"
                    :disabled="true"
                    v-model="lookFormLabelgyd.deliveryDate"
                    type="date"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="创建人" prop="createUserName">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.createUserName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="创建时间" prop="createTime">
                  <el-date-picker
                    style="width: 65%"
                    v-model="lookFormLabelgyd.createTime"
                    :disabled="true"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="最后修改人" prop="updateUserName">
                  <el-input
                    style="width: 65%"
                    v-model="lookFormLabelgyd.updateUserName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="最后修改时间" prop="updateUserName">
                  <el-date-picker
                    style="width: 65%"
                    v-model="lookFormLabelgyd.updateTime"
                    :disabled="true"
                    type="datetime"
                    value-format="yyyy-MM-dd-HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="lookFormVisible = false">保 存</el-button> -->
          <el-button @click="lookFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除改衣单确认取消对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>改衣单信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteGydqd">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出改衣单记录"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>改衣单记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <div class="exporttc">
      <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        :close-on-click-modal="false"
        title="下载改衣单导出文件"
      >
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column
            prop="startTime"
            label="开始执行时间"
          ></el-table-column>

          <el-table-column
            prop="endTime"
            label="结束执行时间"
          ></el-table-column>

          <el-table-column prop="fileName" label="文件名"></el-table-column>

          <el-table-column prop="isComplate" label="状态">
            <template slot-scope="scope">
              {{ scope.row.isComplate ? "完成" : "执行中" }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="下载">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <!-- 首页列表 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="queryInfo"
          size="small"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item :inline="true" label="改衣单号">
                <el-input
                  style="width: 60%"
                  v-model="queryInfo.orderNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :inline="true" label="商品SKU">
                <el-input style="width: 60%" v-model="queryInfo.SKU"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户姓名">
                <el-input
                  style="width: 60%"
                  v-model="queryInfo.custName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :inline="true" label="改衣单状态">
                <el-select style="width: 60%" v-model="queryInfo.state">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已交付" value="0"></el-option>
                  <el-option label="待取衣" value="1"></el-option>
                  <el-option label="修改中" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门店">
                <el-input
                  style="width: 60%"
                  v-model="queryInfo.shopCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="费用类型">
                <el-select style="width: 60%" v-model="queryInfo.payWay">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="自费" value="0"></el-option>
                  <el-option label="保修需报销" value="1"></el-option>
                  <el-option label="保修无需报销" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="销售单号">
                <el-input
                  style="width: 60%"
                  v-model="queryInfo.saleNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="修改类型">
                <el-select style="width: 60%" v-model="queryInfo.modifyKind">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="常规修改" value="0"></el-option>
                  <el-option label="瑕疵修改" value="1"></el-option>
                  <el-option label="皮草修改" value="2"></el-option>
                  <el-option label="配饰修复" value="3"></el-option>
                  <el-option label="其他修改" value="4"></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 60%"
                  v-model="queryInfo.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表内容区 -->
    <el-card shadow="never" class="centercard">
      <el-table
        size="small"
        class="table-style"
        height="500px"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <!-- radio -->
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="radio"
              @change="handleRadioChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
        <el-table-column prop="orderNo" label="改衣单号" min-width="90%">
        </el-table-column>
        <el-table-column prop="custName" label="客户姓名" min-width="60%">
        </el-table-column>
        <el-table-column prop="shopName" label="门店" min-width="70%">
        </el-table-column>
        <el-table-column prop="saleNo" label="销售单号" min-width="90%">
        </el-table-column>
        <el-table-column prop="barCode" label="商品条码" min-width="98%">
        </el-table-column>
        <el-table-column prop="state" label="改衣单状态">
          <template slot-scope="scope">
            {{
              scope.row.state === 0
                ? "已交付"
                : scope.row.state === 1
                ? "待取衣"
                : scope.row.state === 2
                ? "修改中"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="payWay" label="费用类型">
          <template slot-scope="scope">
            {{
              scope.row.payWay === 0
                ? "自费"
                : scope.row.payWay === 1
                ? "保修需报销"
                : scope.row.payWay === 2
                ? "保修无需报销"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="修改费用"> </el-table-column>
        <el-table-column prop="modifyKind" label="修改类型">
          <template slot-scope="scope">
            {{
              scope.row.modifyKind === 0
                ? "常规修改"
                : scope.row.modifyKind === 1
                ? "瑕疵修改"
                : scope.row.modifyKind === 2
                ? "皮草修改"
                : scope.row.modifyKind === 3
                ? "配饰修复"
                : scope.row.modifyKind === 4
                ? "其他修改"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="modifyContext" label="修改内容">
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="70%">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime" label="最后修改时间" min-width="80%">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime !== null">
              {{ scope.row.updateTime | dateFormat }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多啦!"
        type="warning"
        center
        show-icon
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import {
  upDressPageApi,
  ChangeorderNumberApi,
  SelectsalesorderlistApi,
  ChecktheclotheschangelistApi,
  selectCustListApi,
} from "@/api/shop";
import {
  ChangeclotheslistcreateApi,
  modifyGydlistApi,
  DeleteGydlistApi,
  CustupdressexportApi,
} from "@/api/user";
import { reportFormList } from "@/api/reportForm";
import { dateTimes } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 导出
      exportShow: false,
      // 下载弹窗
      downloadShow: false,
      downloadData: [],
      deleteFormVisible: false,
      // 创建弹窗
      foundFormVisible: false,
      // 修改弹窗
      amendFormVisible: false,
      // 查看弹窗
      lookFormVisible: false,
      // 创建内部弹窗
      innerVisible: false,
      innerVisible2: false,
      labelPosition: "right",
      // 首页radio选择数据
      radio: "",
      // 创建弹窗选择销售单radio选择数据
      radioxsd: "",
      // 创建弹窗选择会员radio选择数据
      radiohy: "",
      // // 首页列表查询请求参数
      // formLabelAlign: {
      //   pageNo: 1,
      //   pageSize: 50,
      //   custName: "",
      //   SKU: "",
      //   orderNo: "",
      //   state: "",
      //   payWay: "",
      //   saleNo: "",
      //   shopName: "",
      //   modifyKind: "",
      // },
      // 创建弹窗列表参数
      createhy: {
        orderNo: "",
        saleNo: "",
        shop: "",
        shopName: "",
        custName: "",
        barCode: "",
        state: "1",
        payWay: "",
        fee: "",
        modifyContext: "",
        modifyKind: "",
        deliveryDate: "",
        SKU: "",
        custID: "",
      },
      // 创建弹窗内选择销售单弹窗列表
      Selectsalesorder: [],
      // 首页列表请求参数
      queryInfo: {
        pageNo: 1,
        pageSize: 50,
        pages: 0,
        custName: "",
        SKU: "",
        orderNo: "",
        state: "",
        payWay: "",
        saleNo: "",
        shopCode: "",
        modifyKind: "",
        datePicker: "",
        createTimeStart: "", //创建日期开始
        createTimeEnd: "", //创建日期结束
      },
      // 创建弹窗选择销售单列表请求参数
      createxs: {
        pages: 0,
        pageNo: 1,
        pageSize: 50,
      },
      // 创建弹窗选择销售单列表查询参数
      searchXsFrom: {
        saleNo: "",
        pageNo: 1,
        pageSize: 50,
      },
      // 创建弹窗选择会员列表请求参数
      Selectmember: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
      },
      // 创建弹窗选择会员列表查询参数
      SearchFormHy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
      },
      // 创建会员改衣单的表单验证
      createFormgydRules: {
        orderNo: [
          { required: true, message: "请输入改衣单号", trigger: "blur" },
        ],
        saleNo: [
          { required: true, message: "请输入销售单号", trigger: "blur" },
        ],
        shopName: [{ required: true, message: "请输入门店", trigger: "blur" }],
        custName: [
          { required: true, message: "请输入客户姓名", trigger: "blur" },
        ],
        barCode: [
          { required: true, message: "请输入商品条码", trigger: "blur" },
        ],
      },
      // 改衣单修改
      modifyGydlist: {
        ID: "",
        orderNo: "",
        saleNo: "",
        shop: "",
        shopName: "",
        custName: "",
        barCode: "",
        state: "",
        payWay: "",
        fee: "",
        modifyContext: "",
        modifyKind: "",
        deliveryDate: "",
      },
      // 改衣单删除delete
      DeleteGydlb: {
        ID: "",
      },
      // 查看表单
      lookFormLabelgyd: {},
      lookFormLabelgydcs: {
        ID: "",
      },
      // 首页
      loading: false,
      loadingxs: false,
      loadinghy: false,
      radioValueList: [], //首页选中的数据
      radioValueXsdList: [], //销售单列表选中的数据
      radioValueHyList: [], //会员列表选中的数据
      tableData: [],
      // 内层弹窗销售单数据
      tableData2: [],
      tableData3: [],
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
        daochu: false,
      },
    };
  },
  created() {
    this.alterationsList();
    let Alterations = JSON.parse(localStorage.getItem("Alterations"));
    for (let i = 0; i < Alterations.length; i++) {
      if (Alterations[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Alterations[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Alterations[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Alterations[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Alterations[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (Alterations[i].menuName == "导出") {
        this.jurisdiction.daochu = true;
        continue;
      }
    }
  },
  computed: {
    // 首页
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 创建弹窗选择销售单
    isMorexs() {
      //当起始页数等于总页数时停止加载
      return this.createxs.pageNo >= this.createxs.pages;
    },
    onLoadingxs() {
      return this.loadingxs || this.isMorexs;
    },
    // 创建弹窗选择会员
    isMorehy() {
      //当起始页数等于总页数时停止加载
      return this.Selectmember.pageNo >= this.Selectmember.pages;
    },
    onLoadinghy() {
      return this.loadingxshy || this.isMorehy;
    },
  },
  methods: {
    // 创建弹窗选择会员radio选择获取列表数据
    getSelectHy(row) {
      this.radioValueHyList = row;
    },
    // 创建弹窗选择销售radio选择获取列表数据
    getCurrentRow(row) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.radioValueXsdList = row;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 改衣单首页列表数据
    async alterationsList() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createTimeStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createTimeEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      }
      let data = {
        pageNo: this.queryInfo.pageNo,
        pageSize: this.queryInfo.pageSize,
        pages: this.queryInfo.pages,
        custName: this.queryInfo.custName,
        SKU: this.queryInfo.SKU,
        orderNo: this.queryInfo.orderNo,
        state: this.queryInfo.state,
        payWay: this.queryInfo.payWay,
        saleNo: this.queryInfo.saleNo,
        shopCode: this.queryInfo.shopCode,
        modifyKind: this.queryInfo.modifyKind,
        createTimeStart: this.queryInfo.createTimeStart, //创建日期开始
        createTimeEnd: this.queryInfo.createTimeEnd, //创建日期结束
      };
      await upDressPageApi(data).then((res) => {
        if (this.queryInfo.pageNo == 1) this.tableData = [];
        this.tableData = this.tableData.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.alterationsList();
      }, 1000);
    },
    // 点击radio获取首页表格数据
    handleRadioChange(value) {
      this.radioValueList = value;
    },
    // 选择销售单列表
    async Selectsalesorderlist() {
      await SelectsalesorderlistApi(this.createxs).then((res) => {
        this.tableData2 = res.data.list;
        this.createxs.pages = res.data.pages;
        this.loadingxs = false;
      });
    },
    loadxs() {
      // 滑到底部时进行加载
      this.loadingxs = true;
      setTimeout(() => {
        this.createxs.pageSize += 50; //页数据+50
        this.Selectsalesorderlist(); //调用接口，此时页数据+50，查询下一个50数据
      }, 1000);
    },
    // 创建弹窗点击选择销售单事件
    Salesslip() {
      this.Selectsalesorderlist();
      this.innerVisible = true;
    },
    // 销售单列表点击选中数据传值
    selectxsd() {
      this.createhy.custID = this.radioValueXsdList.custID;
      this.createhy.SKU = this.radioValueXsdList.sku;
      this.createhy.saleNo = this.radioValueXsdList.saleNo;
      this.createhy.shop = this.radioValueXsdList.saleShop;
      this.createhy.shopName = this.radioValueXsdList.shopName;
      this.createhy.barCode = this.radioValueXsdList.barCode;
      this.createhy.custName = this.radioValueXsdList.custName;
      this.innerVisible = false;
    },
    // 选择会员列表
    async SelectmemberlistApi() {
      await selectCustListApi(this.Selectmember).then((res) => {
        this.tableData3 = res.data.list;
        this.Selectmember.pages = res.data.pages;
        this.loadinghy = false;
      });
    },
    loadhy() {
      //滑到底部时进行加载
      this.loadinghy = true;
      setTimeout(() => {
        this.Selectmember.pageSize += 50; //页面数据每次+50
        this.SelectmemberlistApi(); //调用接口，此时页面数据+50，获取下一次50数据
      }, 1000);
    },
    // 点击创建获取改衣单号
    Clickcreate() {
      this.gaiyidanhaoE();
      this.foundFormVisible = true;
    },
    // 创建弹窗点击选择会员事件
    Selecthy() {
      this.SelectmemberlistApi();
      this.innerVisible2 = true;
    },
    // 会员列表点击选中数据传值
    selecthycz() {
      this.createhy.custName = this.radioValueHyList.custName;
      this.innerVisible2 = false;
    },
    // 获取改衣单号
    gaiyidanhaoE() {
      ChangeorderNumberApi({ orderNo: "" }).then((res) => {
        this.createhy.orderNo = res.data;
      });
    },
    // 首页搜索
    async searchGyd() {
      this.radio = "";
      this.radioValueList = "";
      this.queryInfo.pageNo = 1;
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createTimeStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createTimeEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      }
      let data = {
        pageNo: this.queryInfo.pageNo,
        pageSize: this.queryInfo.pageSize,
        pages: this.queryInfo.pages,
        custName: this.queryInfo.custName,
        SKU: this.queryInfo.SKU,
        orderNo: this.queryInfo.orderNo,
        state: this.queryInfo.state,
        payWay: this.queryInfo.payWay,
        saleNo: this.queryInfo.saleNo,
        shopCode: this.queryInfo.shopCode,
        modifyKind: this.queryInfo.modifyKind,
        createTimeStart: this.queryInfo.createTimeStart, //创建日期开始
        createTimeEnd: this.queryInfo.createTimeEnd, //创建日期结束
      };
      await upDressPageApi(data).then((res) => {
        if (res.message !== "success") {
          this.$message.error("查询会员失败");
          return;
        }
        this.$message.success("查询会员成功");
        this.tableData = res.data.list;
        this.queryInfo.pages = res.data.pages;
      });
    },
    // 选择销售单查询
    async SearchXsd() {
      await SelectsalesorderlistApi(this.searchXsFrom).then((res) => {
        this.tableData2 = res.data.list;
      });
    },
    // 选择会员查询
    async SearchHy() {
      await selectCustListApi(this.SearchFormHy).then((res) => {
        this.tableData3 = res.data.list;
      });
    },
    // 监听创建对话框的关闭事件
    CreatedClosed() {
      this.$refs.createhyRef.resetFields();
    },
    // 监听修改对话框的关闭事件
    modifyClosed() {
      this.$refs.modifyGydlistRef.resetFields();
    },
    // 监听查看对话框关闭事件
    SeeGydlbClose() {
      this.$refs.SeeGydlbRef.resetFields();
    },
    // 改衣单创建
    addGyd(createhyRef) {
      this.$refs[createhyRef].validate(async (valid) => {
        if (!valid) return;
        // 可以发送请求创建改衣单
        let createdhy = {
          orderNo: this.createhy.orderNo,
          saleNo: this.createhy.saleNo,
          shop: this.createhy.shop,
          shopName: this.createhy.shopName,
          custName: this.createhy.custName,
          barCode: this.createhy.barCode,
          state: this.createhy.state,
          payWay: this.createhy.payWay,
          fee: this.createhy.fee,
          modifyContext: this.createhy.modifyContext,
          modifyKind: this.createhy.modifyKind,
          deliveryDate:
            this.createhy.deliveryDate != ""
              ? dateTimes(this.createhy.deliveryDate)
              : undefined,
          SKU: this.createhy.SKU,
          custID: this.createhy.custID,
        };
        await ChangeclotheslistcreateApi(createdhy).then((res) => {
          if (res.message !== "success") {
            this.$message.error("创建改衣单失败");
            return;
          }
          this.$message.success("创建改衣单成功");
          // 隐藏创建改衣单对话框
          this.foundFormVisible = false;
          // 重新获取改衣单列表
          this.alterationsList();
          this.radio = "";
          this.radioValueList = "";
        });
      });
    },
    // 改衣单修改
    async modifyGydqd() {
      let modifyGyd = {
        ID: this.modifyGydlist.ID,
        orderNo: this.modifyGydlist.orderNo,
        saleNo: this.modifyGydlist.saleNo,
        shop: this.modifyGydlist.shop,
        custName: this.modifyGydlist.custName,
        barCode: this.modifyGydlist.barCode,
        state: this.modifyGydlist.state,
        payWay: this.modifyGydlist.payWay,
        fee: this.modifyGydlist.fee,
        modifyContext: this.modifyGydlist.modifyContext,
        modifyKind: this.modifyGydlist.modifyKind,
        deliveryDate:
          this.modifyGydlist.deliveryDate !== null || ""
            ? dateTimes(this.modifyGydlist.deliveryDate)
            : undefined,
      };
      await modifyGydlistApi(modifyGyd).then((res) => {
        if (res.message !== "success") {
          this.$message.error("修改改衣单记录失败");
          return;
        }
        this.$message.success("修改改衣单记录成功");
        // 重新获取改衣单列表
        this.alterationsList();
        this.radio = "";
        this.radioValueList = "";
      });
      // 关闭弹窗
      this.amendFormVisible = false;
    },
    modifyGyd() {
      if (this.radioValueList.length == 0) {
        this.$message.error("请选择单条数据，进行修改");
      } else {
        this.amendFormVisible = true;
        this.modifyGydlb();
      }
    },
    modifyGydlb() {
      this.modifyGydlist.ID = this.radioValueList.id;
      this.modifyGydlist.orderNo = this.radioValueList.orderNo;
      this.modifyGydlist.saleNo = this.radioValueList.saleNo;
      this.modifyGydlist.shop = this.radioValueList.shop;
      this.modifyGydlist.shopName = this.radioValueList.shopName;
      this.modifyGydlist.custName = this.radioValueList.custName;
      this.modifyGydlist.barCode = this.radioValueList.barCode;
      this.modifyGydlist.state = this.radioValueList.state;
      this.modifyGydlist.payWay = this.radioValueList.payWay;
      this.modifyGydlist.fee = this.radioValueList.fee;
      this.modifyGydlist.modifyContext = this.radioValueList.modifyContext;
      this.modifyGydlist.modifyKind = this.radioValueList.modifyKind;
      this.modifyGydlist.deliveryDate = this.radioValueList.deliveryDate;
      console.log(this.modifyGydlist.deliveryDate);
    },
    // 改衣单查看 -- 点击查看 查看改衣单记录
    lookgyd() {
      if (this.radioValueList.length == 0) {
        this.$message.error("请选择单条数据，进行查看");
      } else {
        // 获取id
        this.lookgydqq();
        // 发送请求查看记录
        ChecktheclotheschangelistApi(this.lookFormLabelgydcs).then((res) => {
          this.lookFormLabelgyd = res.data;
          if (res.message !== "success") {
            this.$message.error("查看改衣单失败");
            return;
          }
          this.$message.success("查看改衣单成功");
        });
        // 打开查看弹窗
        this.lookFormVisible = true;
      }
    },
    // 获取id事件
    lookgydqq() {
      this.lookFormLabelgydcs.ID = this.radioValueList.id;
    },
    // 改衣单 -- 删除
    async deleteGydqd() {
      await DeleteGydlistApi(this.DeleteGydlb).then((res) => {
        if (res.message !== "success") {
          this.$message.error("删除改衣单记录失败");
          return;
        }
        this.$message.success("删除改衣单记录成功");
        // 重新获取改衣单列表
        this.alterationsList();
        this.radio = "";
        this.radioValueList = "";
      });
      // 关闭弹窗
      this.deleteFormVisible = false;
    },
    // 判断有没有选中数据 获得ID
    Deletegyd() {
      if (this.radioValueList.length == 0) {
        this.$message.error("请选择单条数据，进行删除");
      } else {
        this.deletedydqq();
        this.deleteFormVisible = true;
      }
    },
    // 获得id事件
    deletedydqq() {
      this.DeleteGydlb.ID = this.radioValueList.id;
      console.log(this.DeleteGydlb.ID);
    },
    // 导出
    Export() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createTimeStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createTimeEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      }
      let data = {
        pageNo: this.queryInfo.pageNo,
        pageSize: this.queryInfo.pageSize,
        // pages: this.queryInfo.pages,
        custName: this.queryInfo.custName,
        SKU: this.queryInfo.SKU,
        orderNo: this.queryInfo.orderNo,
        state: this.queryInfo.state,
        payWay: this.queryInfo.payWay,
        saleNo: this.queryInfo.saleNo,
        shopCode: this.queryInfo.shopCode,
        modifyKind: this.queryInfo.modifyKind,
        createTimeStart: this.queryInfo.createTimeStart, //创建日期开始
        createTimeEnd: this.queryInfo.createTimeEnd, //创建日期结束
      };
      CustupdressexportApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("导出失败!!!");
        } else {
          this.exportShow = false;
          this.$message.success("导出成功请在下载列表查看!");
        }
      });
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "改衣单导出",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
  },
};
</script>
<style lang="scss" scoped>
#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 10px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-dialog__body {
  padding: 30px 60px;
}
.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 修改弹窗样式
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 创建弹窗样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 查看弹窗样式
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 导出弹框样式
  .exporttc {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .el-dialog__header {
    padding: 1.25rem 1.25rem 0.625rem;
    background-color: #d1cda5;
  }
  // 创建弹窗text文本框
  // .el-textarea__inner{
  //   min-height: 100px;
  // }
}
</style>
